import { useMemo } from 'react';

import type { NavigationItem } from '@af/design-system-docs-ui';

import { getNavigationItems } from './navigation-items';

const useSideNavigation = (): NavigationItem[] => {
	const navigationItems = useMemo(() => {
		return getNavigationItems();
	}, []);

	return navigationItems;
};

export default useSideNavigation;
